var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8387 24.8387 32 16 32C7.16129 32 -2.17147e-06 24.8387 -1.39876e-06 16C-6.2606e-07 7.16129 7.16129 -2.17147e-06 16 -1.39876e-06C24.8387 -6.2606e-07 32 7.16129 32 16ZM16 2.06451C8.34193 2.06451 2.06451 8.26451 2.06451 16C2.06451 23.6581 8.26451 29.9355 16 29.9355C23.6581 29.9355 29.9355 23.7355 29.9355 16C29.9355 8.34194 23.7355 2.06452 16 2.06451ZM15.1935 8.03226L7.76774 15.4516C7.46451 15.7548 7.46451 16.2452 7.76774 16.5484L15.1935 23.9677C15.4968 24.271 15.9871 24.271 16.2903 23.9677L16.7355 23.5226C17.0387 23.2194 17.0387 22.7161 16.7226 22.4194L11.2 17.0968L23.4839 17.0968C23.9097 17.0968 24.2581 16.7484 24.2581 16.3226L24.2581 15.6774C24.2581 15.2516 23.9097 14.9032 23.4839 14.9032L11.2065 14.9032L16.729 9.58064C17.0387 9.27742 17.0452 8.78064 16.7419 8.47742L16.2968 8.03226C15.9871 7.72903 15.4968 7.72903 15.1935 8.03226Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCircleArrow);
export default __webpack_public_path__ + "static/media/left-circle-arrow.0540fae031152cbbf1d9fb556ab600ae.svg";
export { ForwardRef as ReactComponent };